var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletWithBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#E5B909",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6422 12.75C33.95 12.75 36.4956 15.2233 36.4956 19.4223V19.4689H31.2022C28.7389 19.4732 26.7433 21.4189 26.7389 23.8207C26.7356 26.2279 28.7333 28.1823 31.2022 28.1855H36.5V28.5679C36.5 32.767 33.9544 35.25 29.6467 35.25H18.3544C14.0456 35.25 11.5 32.767 11.5 28.5679V19.4223C11.5 15.2233 14.0456 12.75 18.3544 12.75H29.6422ZM24.4789 17.5936H17.4244C16.9 17.5958 16.4744 18.0107 16.4722 18.5231C16.47 19.0377 16.8967 19.457 17.4244 19.4592H24.4878C25.0156 19.457 25.4422 19.0377 25.44 18.5221C25.4378 18.0075 25.0067 17.5915 24.4789 17.5936Z",
    fill: "#E5B910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29.0468 24.3708C29.3082 25.5598 30.3506 26.3963 31.5407 26.3746H35.6031C36.0983 26.3746 36.5 25.9645 36.5 25.4576V22.2931C36.4989 21.7873 36.0983 21.3761 35.6031 21.375H31.4451C30.0913 21.3794 28.9979 22.5031 29 23.8878C29 24.0499 29.0159 24.212 29.0468 24.3708Z",
    fill: "#E5B910"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 25.125C32.1904 25.125 32.75 24.5654 32.75 23.875C32.75 23.1846 32.1904 22.625 31.5 22.625C30.8096 22.625 30.25 23.1846 30.25 23.875C30.25 24.5654 30.8096 25.125 31.5 25.125Z",
    fill: "#E5B910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletWithBg);
export default __webpack_public_path__ + "static/media/wallet-with-bg.daa3cb99b626aa3c75244b95d009fc3d.svg";
export { ForwardRef as ReactComponent };